export default "__VITE_ASSET__CahRrLTb__"